import { Database, BrainCircuit, Target } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Database,
    title: "Data Integration",
    body:
      "Every conversation starts with the data. Chris opens with a diagnostic of how CRM, product, and revenue signals feed one another — because clean pipes precede clever models, every time.",
    detail: "CRM · Warehouse · Product Telemetry",
  },
  {
    n: "02",
    icon: BrainCircuit,
    title: "AI Enablement",
    body:
      "Chris advises on where AI genuinely compounds — copilots for reps, marketers and RevOps, automated research, and forecast intelligence — and just as importantly, where it's noise. Your team ships; the counsel keeps the plays honest.",
    detail: "Copilots · Scoring · Automation",
  },
  {
    n: "03",
    icon: Target,
    title: "Optimized Execution",
    body:
      "Operating cadence, dashboards and playbooks stay with your team. Chris keeps the thesis current — pressure-testing bets, reviewing outcomes, and helping choose what to compound next.",
    detail: "Cadence · Dashboards · Playbooks",
  },
];

export const Framework = () => {
  return (
    <section
      id="framework"
      data-testid="framework-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <div className="text-xs font-mono-ui uppercase tracking-[0.28em] text-violet-400 mb-4">
            ─── The Efficiency Framework
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tighter text-zinc-50">
            How AI compounds inside a
            <span className="text-zinc-500"> disciplined GTM motion.</span>
          </h2>
        </div>

        <div className="relative mt-20">
          {/* Connecting line (desktop) */}
          <div
            className="hidden md:block absolute top-16 left-[8%] right-[8%] h-px bg-gradient-to-r from-transparent via-violet-500/40 to-transparent"
            aria-hidden
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 relative">
            {steps.map((s) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.n}
                  data-testid={`framework-step-${s.n}`}
                  className="relative"
                >
                  <div className="flex items-center gap-4 mb-6">
                    <span className="relative inline-flex h-12 w-12 items-center justify-center bg-zinc-950 border border-white/15 z-10">
                      <Icon
                        className="h-5 w-5 text-violet-300"
                        strokeWidth={1.5}
                      />
                    </span>
                    <span className="font-mono-ui text-xs uppercase tracking-[0.24em] text-zinc-500">
                      Step {s.n}
                    </span>
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight text-zinc-50">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-zinc-400 leading-relaxed max-w-sm">
                    {s.body}
                  </p>
                  <div className="mt-6 inline-flex items-center gap-2 text-[11px] font-mono-ui uppercase tracking-[0.2em] text-zinc-500 border border-white/10 px-3 py-1.5">
                    {s.detail}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
